import Create from "./Create";
import Delete from "./Delete";
import showAll from "./showAll";
import show from "./showDetails";

const Voting = {
  Create,
  Delete,
  showAll,
  show,
};

export default Voting;

export { Create, Delete, showAll, show };
